import { fetcher } from './apiClient';

export type DeviceTag = {
    id: string;
    orgId: string;
    label: string;
    createdAt: string;
    updateAt: string;
};

const deviceTagFetcher = async (url: string): Promise<DeviceTag> => {
    const res = await fetcher<DeviceTag>(url);
    return {
        id: res.id,
        orgId: res.orgId,
        label: res.label,
        createdAt: res.createdAt,
        updateAt: res.updateAt,
    } as DeviceTag;
};

const listDeviceTagFetcher = async (url: string): Promise<DeviceTag[]> => {
    return await fetcher<DeviceTag[]>(url);
};

export { deviceTagFetcher, listDeviceTagFetcher };
